<template>
  <transition name="el-fade-in-linear">
    <div v-show="transitionshow">

      <el-form ref="create" :model="create" :rules="rules" size="small" label-width="100px">
        <div class="backborder3">
          <el-col :span="24">
            <el-col :span="7">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="create.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="编号" prop="number">
                <el-input v-model="create.number"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="职员类型" prop="type">
                <el-select v-model="create.type" placeholder="请选择职员类型">
                  <el-option label="直营" value="1"></el-option>
                  <el-option label="合作" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-col>
        </div>
        <div class="backborder3" style="margin-top:10px">
          <el-col :span="24">
            <el-col :span="7">
              <el-form-item label="选择组别">
                <el-select v-model="create.groupid" placeholder="请选择客户分类">
                  <el-option v-for="(item, index) in grouplists" :label="item.name" :value="item.id"
                    :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="生日">
                <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="出生日期"
                  v-model="create.birthday"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-col>
        </div>
        <div class="backborder3" style="margin-top:10px">
          <el-col :span="24">
            <el-col :span="7">
              <el-form-item label="联系电话">
                <el-input v-model="create.phone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="地址">
                <el-input v-model="create.address"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="是否默认线上商城发货销售员" label-width="140">
                <el-radio-group v-model="create.ismall">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <!-- 默认销售员类型 -->
            <el-col :span="24" v-if="iskingdee == 1">
              <el-col :span="8">
                <el-form-item label="金蝶业务员类型" label-width="150">
                  <el-input v-model="create.kingdeetype" style="width:60%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-tag type="danger" size="mini">注：请参照金蝶系统职员列表任职岗位进行填写</el-tag>
              </el-col>
            </el-col>
            <!-- 金蝶 -->
            <el-col :span="24" v-if="iskingdee == 1">
              <el-col :span="8">
                <el-form-item label="金蝶员工任岗编码" label-width="150">
                  <el-input v-model="create.kingdeecode" style="width:60%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-tag type="danger" size="mini">注：请参照金蝶系统职员列表员工任岗编码进行填写</el-tag>
              </el-col>
            </el-col>


            <el-col :span="24" align="right">
              <el-form-item>
                <el-button size="small" type="primary" :loading="createLoading" @click="createSave">保 存</el-button>
              </el-form-item>
            </el-col>
          </el-col>
        </div>
      </el-form>
    </div>
  </transition>
</template>

<script>

export default {
  data() {
    return {
      actionauth: '', //功能权限
      transitionshow: true,
      url: this.GLOBAL.domain + "Clerk/index",
      createDialog: false,
      create: {
        act: 'add',
        token: this.$cookies.get('token'),
        name: '',
        number: '',
        birthday: '',
        phone: '',
        address: '',
        ismall: 0,
        kingdeetype: '销售员',
        type: '1',
        kingdeecode: '',
      },
      creategroupDialog: false,
      groupLoading: false,
      group: {
        url: this.GLOBAL.domain + "Clerk/index",
        token: this.$cookies.get('token'),
        act: 'lists',
        name: '',
        id: '',
        p: 1,
        rollpage: 10000
      },
      grouplists: [],
      createLoading: false,
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符' }
        ],
        number: [
          { required: true, message: '请输入编号', trigger: 'blur' },
          { pattern: /^[0-9]+$/, message: '编号只能为数字' }
        ],
        type: [
          { required: true, message: '请选择职员类型', trigger: 'blur' }
        ]
      },
      addclerkrules: {
        name: [
          { required: true, message: '请输入组别名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符' }
        ],
      },
      editclerkrules: {
        name: [
          { required: true, message: '请输入组别名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符' }
        ],
      },
      iskingdee: 0,

    }
  },
  mounted() {
    this.getactionauth();
    this.getclerkgrouplists(); //获取职员组别信息
    this.checkiskingdee(); //检测是否有金蝶信息的提交权限

  },
  methods: {

    /** 获取功能权限 **/
    getactionauth() {
      var data = this.$cookies.get('actionauth');
      data = JSON.parse(data);
      this.actionauth = data;
    },

    /** 查看当前代理商是否开启了金蝶权限 **/
    checkiskingdee() {
      var resource = this.$resource(this.GLOBAL.domain + "kingdee/index");
      resource.save({ act: 'isopenkingdee', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.iskingdee = result.iskingdee;
        }
      }).catch((res) => {

      });
    },

    /** 获取职员组别列表 **/
    getclerkgrouplists() {
      this.creategroupDialog = true;
      this.groupLoading = true;
      this.group.act = 'getclerkgrouplists';
      var resource = this.$resource(this.group.url);
      resource.query(this.group).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login');
            this.groupLoading = false;
          }
          this.$message.error(res.data.Message);
          this.groupLoading = false;
        } else {
          this.grouplists = JSON.parse(Base64.decode(res.data.Data));
          this.groupLoading = false;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.groupLoading = false;
      });
    },


    //新增
    createSave() {
      // 主动校验
      this.$refs.create.validate((valid) => {
        if (!valid) return false;

        this.createLoading = true;
        var resource = this.$resource(this.url);
        resource.save(this.create).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
            this.createLoading = false;
          } else {
            this.$message.success(res.data.Message);
            this.createLoading = false;
            this.reset();
          }
        }).catch((res) => {
          this.createLoading = false;
        });

      });
    },

    //重置表单
    reset() {
      this.create.name = '';
      this.create.number = '';
      this.create.birthday = '';
      this.create.phone = '';
      this.create.address = '';
    },



  }
}
</script>
<style>
.backborder1 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 0 1%
}

.backborder3 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  float: left;
  width: 98%;
  padding: 1% 1% 0 1%;
}
</style>


// WEBPACK FOOTER //
// src/components/base/Clerkadd.vue